export default __webpack_public_path__ + "static/media/Optus.6310cf66.svg";